import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import { setColor, setFont } from "../../../../../assets/styles/styles";
import Typography from "../../../../../components/common/text/Typography";
import UploadFile from "../../../../../components/common/fileUploader/FileUploaderInput";
import Button from "../../../../../components/common/button/Button";
import JsonViewerModal from "../../vanityLinks/components/JsonViewerModal";
import Modal from "../../../components/Modal";
import { CACHE_QUERY_OPTIONS } from "../../../../../constants";
import { getAllRoomPreset } from "../../../../../api/ClientsTagController";
import Dropdown from "../../../../../components/common/inputDropdown/Dropdown";

const CreateTagSetting = ({ tagSettingState, setTagSettingState, step, setStep, uploadLoadingScreenImage }) => {
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [selectedBGImg, setSelectedBGImg] = useState(null);

    const [isJsonEditorOpen, setIsJsonEditorOpen] = useState(false);
    const [jsonEditorValue, setJsonEditorValue] = useState("");

    const [errorMessage, setErrorMessage] = useState(false);

    const { data: presetData } = useQuery(["roomPresets"], getAllRoomPreset, {
        ...CACHE_QUERY_OPTIONS(),
    });

    const setPresetData = (value) => {
        const selectedPreset = presetData?.roomPresets?.find((item) => item.presetName === value);
        updateTagSettingState("presetId", selectedPreset?.presetId || "");
        updateTagSettingState("settingPresetName", value || "");
    };

    const updateTagSettingState = (key, value) => {
        if (key === "settingPresetName" && value.trim() === "") {
            setButtonDisabled(true);
        } else {
            setButtonDisabled(false);
        }

        if (key.includes(".")) {
            const [parent, child] = key.split(".");
            setTagSettingState((prevState) => ({
                ...prevState,
                [parent]: {
                    ...prevState[parent],
                    [child]: value,
                },
            }));
        } else {
            setTagSettingState((prevState) => ({
                ...prevState,
                [key]: value,
            }));
        }
    };


    return (
        <>
            <ModalContent>
                <GeneralContainer>
                    <Typography variant="h2PurpleHeading" margin={`1rem 0 0 0`} fontSize={"24px"}>
                        {" "}
                        Step 2: Create Client Tag Settings
                    </Typography>
                    <Table>
                        <TableRow>
                            <TableColumn>
                                <Dropdown
                                    key={"presetDataInput"}
                                    label="Room Preset*"
                                    items={presetData?.roomPresets?.map((item) => ({
                                        ...item,
                                        value: item.presetName,
                                    }))}
                                    selectedValue={tagSettingState.presetId}
                                    setSelectedValue={setPresetData}
                                    placeholder="Select Room Preset"
                                />
                            </TableColumn>
                        </TableRow>
                        {/* <TableRow>
                            <TableColumn>
                                <Label>Client Tag Setting Name*</Label>
                                <InputBox
                                    type="text"
                                    id="Client Tag Setting"
                                    placeholder="Client Tag Setting"
                                    value={tagSettingState.name}
                                    onChange={(e) => updateTagSettingState("settingPresetName", e.target.value)}
                                />
                            </TableColumn>
                        </TableRow> */}

                        <UploadFile
                            label="loading screen Image"
                            accept={["image/png", "image/jpeg", "image/jpg"]}
                            selectedFile={selectedBGImg}
                            setSelectedFile={setSelectedBGImg}
                            source="withoutCallingFileUploadAPI"
                        />
                        {errorMessage && (
                            <TextContent hasError fontsize={"14px"}>
                                {"File size should be less than 1MB"}
                            </TextContent>
                        )}

                        <TableRow>
                            <TableColumn>
                                <Label>Loading Message</Label>
                                <InputBox
                                    type="text"
                                    id="Client Tag Setting"
                                    placeholder="Loading Message"
                                    value={tagSettingState.loadingMessage.default}
                                    onChange={(e) => updateTagSettingState("loadingMessage.default", e.target.value)}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label>Login Text</Label>
                                <InputBox
                                    type="text"
                                    id="Client Tag Setting"
                                    placeholder="Login Text"
                                    value={tagSettingState.loginText}
                                    onChange={(e) => updateTagSettingState("loginText", e.target.value)}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label>Login Url</Label>
                                <InputBox
                                    type="text"
                                    id="Client Tag Setting"
                                    placeholder="Login Url"
                                    value={tagSettingState.loginUrl}
                                    onChange={(e) => updateTagSettingState("loginUrl", e.target.value)}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label>Meta data</Label>
                                <InputBox
                                    type="text"
                                    name={"metaData"}
                                    value={JSON.stringify(tagSettingState.metaData || {})}
                                    onClick={() => {
                                        setIsJsonEditorOpen(true);
                                        setJsonEditorValue(JSON.stringify(tagSettingState.metaData || {}, null, 2));
                                    }}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <Button
                                // type="submit"
                                variant={"PinkButton"}
                                buttonWidth={"100%"}
                                disabled={buttonDisabled}
                                label={`Create Client Tag Setting`}
                                onClick={async () => {
                                    if (selectedBGImg) {
                                        try {
                                            const res = await uploadLoadingScreenImage(selectedBGImg);
                                            if (res?.status === 200 || res?.status === 201) {
                                                setStep(step + 1);
                                            } else {
                                                console.error("Error uploading loading screen image:", res);
                                                setErrorMessage(true);
                                            }
                                        } catch (error) {
                                            console.error("Error uploading loading screen image:", error);
                                            setErrorMessage(true);
                                        }
                                    } else {
                                        setStep(step + 1);
                                    }
                                }}
                            />
                        </TableRow>
                    </Table>
                </GeneralContainer>
            </ModalContent>

            {isJsonEditorOpen && (
                <Modal
                    isOpen={isJsonEditorOpen}
                    setIsOpen={setIsJsonEditorOpen}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={jsonEditorValue}
                            handleJsonSave={(data) => {
                                setTagSettingState((prev) => ({
                                    ...prev,
                                    metaData: data,
                                }));
                                setIsJsonEditorOpen(false);
                            }}
                            fieldName={"metaData"}
                            label={"metaData"}
                            closeModal={() => setIsJsonEditorOpen(false)}
                        />
                    }
                />
            )}
        </>
    );
};

export default CreateTagSetting;

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: ${setColor.inputText};
`;

const GeneralContainer = styled.div`
    width: 80%;
    font-family: "Barlow-Regular", Helvetica;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-top: 15px;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Table = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-radius: 5px;
    color: #fbfcff;
`;

const TableRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const TableColumn = styled.div`
    flex: 1;
    padding: 5px;
`;

const Label = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 0rem 0rem 0rem 0rem;
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;

const TextContent = styled.p`
    color: ${(props) => (props.hasError ? setColor.errorColor : setColor.circularProgress)};
    text-align: left;
    font-family: ${setFont.barlow}, sans-serif;
    font-size: ${(props) => (props.fontsize ? props.fontsize : "13px")};
    font-style: normal;
    line-height: normal;
    margin: 5px;
    letter-spacing: 0.5px;
    font-weight: 400;

    @media (max-width: 768px) {
        margin-bottom: 20px;
    }
`;
